/**
 * PromiseZ构造函数 支持多次resolve或者reject
 * 注意：PromiseZ函数与原生的Promise使用方法基本类似，但要注意以下几点
 * 1. PromiseZ 即使已经改变状态，其后再次跟then函数也不会立即触发，只会继续挂载函数，等待下一次 onFulfilled 或者 onRejected
 * 2. PromiseZ 不支持在then方法里再返回PromiseZ 但是可以返回 Promise，由于PromiseZ可以多次改变状态，如果再返回可变状态会导致后续then方法的触发非常乱，难以辨认
 * 3. PromiseZ 出现的意义仅仅在于部分更新UI逻辑依赖缓存和后台请求双向走，甚至三向，如果没有多次改变状态的需求，强烈建议还是使用原生Promise
 */
const PENDING = 'pending';
const RESOLVED = 'resolved';
const REJECTED = 'rejected';

function PromiseZ(executor) {
  const self = this;
  self.status = PENDING; // Promise状态 初始化为 PENDING
  self.value = undefined; // 存储成功数据
  self.reason = undefined; // 存储失败数据
  self.onFulfilledCb = []; // 成功回调
  self.onRejectedCb = []; // 失败回调

  function resolve(value) {
    // 如果当前状态不是pending,直接结束
    // 这里我们改造了原有的promise允许多次触发需关掉
    // if (self.status !== PENDING) {
    //  return;
    // }

    // 状态为resolved
    self.status = RESOLVED;
    // 保存value数据
    self.value = value;
    setTimeout(() => {
      self.onFulfilledCb.forEach((cb) => {
        cb(value);
      });
    }, 0);
  }

  function reject(reason) {
    // 如果当前状态不是pending,直接结束
    // 这里我们改造了原有的promise允许多次触发需关掉
    // if (self.status !== PENDING) {
    //  return;
    // }
    // 状态为rejected
    self.status = REJECTED;
    // 保存错误原因
    self.reason = reason;
    setTimeout(() => {
      self.onRejectedCb.forEach((cb) => {
        cb(reason);
      });
    }, 0);
  }

  try {
    executor(resolve, reject); // 代码错误直接进入异常处理
  } catch (error) {
    reject(error);
  }
}

/**
 * 指定成功和失败的回调函数
 */
PromiseZ.prototype.then = function (onFulfilled, onRejected) {
  const self = this;
  let promise2 = null;
  // resolve
  onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : value => value;
  // reject
  onRejected = typeof onRejected === 'function' ? onRejected : (reason) => {
    throw reason;
  };

  // 返回一个新的PromiseZ对象
  promise2 = new PromiseZ((resolve, reject) => {
    self.onFulfilledCb.push((value) => {
      try {
        const x = onFulfilled(value);
        self.resolvePromise(promise2, x, resolve, reject);
        // resolve(x)
      } catch (error) {
        reject(error);
      }
    });

    self.onRejectedCb.push((value) => {
      try {
        const x = onRejected(value);
        self.resolvePromise(promise2, x, resolve, reject);
        // resolve(x)
      } catch (error) {
        reject(error);
      }
    });
  });
  return promise2;
};

/**
 * 指定失败的回调函数
 */
PromiseZ.prototype.resolvePromise = function (promise2, x, resolve, reject) {
  const self = this;
  let then;
  // 避免状态多次变更 加锁
  let called = false;
  // console.log(`promise2 === x: ${promise2 === x}`)
  if (promise2 === x) {
    return reject(new Error('promise2 === x is not allowed'));
  }
  // console.log(`x instanceof PromiseZ: ${x instanceof PromiseZ}`)
  if (x instanceof PromiseZ) {
    // 这里禁用了then方法中返回PromiseZ，本身就已经支持多级then函数
    // 如果then函数再返回支持多次then的PromiseZ对象，后面的then函数触发会变得非常不可控，但是这里可以返回Promise对象，因为Promise对象状态只会变更一次
    // x.then(resolve, reject)
    reject(new Error('forbid return PromiseZ'));
  } else if (typeof x === 'object' || typeof x === 'function') {
    // 支持返回Promise
    try {
      then = x.then;
      if (typeof then === 'function') {
        then.call(x, (y) => {
          if (called) return;
          called = true;
          return self.resolvePromise(promise2, y, resolve, reject);
        }, (r) => {
          if (called) return;
          called = true;
          return reject(r);
        });
      } else {
        resolve(x);
      }
    } catch (e) {
      if (called) return;
      called = true;
      reject(e);
    }
  } else {
    resolve(x);
  }
};

/**
 * 指定失败的回调函数
 */
PromiseZ.prototype.catch = function (onRejected) {
  return this.then(undefined, onRejected);
};

/**
 * finally 简单实现
 */

PromiseZ.prototype.finally = function (callback) {
  return this.then(
    (value) => {
      callback();
      return value;
    },
    (reason) => {
      callback();
      throw reason;
    },
  );
};

export default PromiseZ;
